<template >
 
    <div v-if="src" class="apng-div" ref="wrap" :style="{width:width,height:height}">
      <canvas ref="apng-canvas"></canvas>
    </div>
</template>

<script>
// require('./../libs/apng-canvas.min.js')
import parseAPNG from 'apng-js'
export default {
  data() {
    return {
      wrapWidth:0,
      wrapHeight:0
    }
  },

  props: {
    width: {
      type: String | Number,
      required: true
    },
    height: {
      type: String | Number,
      required: true
    },
    src: {
      type: String,
      required: true
    },
    numPlays:{
      type:String | Number,
      default:()=>{
        return 1
      }
    },
    duration:{ //延迟
      type:String | Number,
      default:()=>{
          return 0
        }
    },
    stopFram:{
      type:String | Number,
      default:()=>{
        return 0
      }
    }
  },

  mounted() {
   
    this.initCanvas()
   
    window.addEventListener('resize',()=>{
      this.initCanvas()
    })
   
  },
  methods: {
    initCanvas(){
      this.getWrap()
      let canvas = this.$refs['apng-canvas'];
      this.loaderURL(this.src).then(blob => {
      this.blobToArrayBuffer(blob).then(arrayBuffer => {
          let apng = parseAPNG(arrayBuffer);
          apng.numPlays = +this.numPlays //设置循环次数
          canvas.width = apng.width;
          canvas.height = apng.height;
          let scale = this.wrapWidth  / apng.width  //宽高比目前只有宽度比例
          canvas.style = 'zoom:'+scale;
          apng.getPlayer(canvas.getContext('2d')).then(player => {
            if(this.duration){
              setTimeout(()=>{player.play()},this.duration)
            }else{
              
              player.play()
            }
            player.on('frame', (frame) => { 
              if(frame==this.stopFram ||this.stopFram ==0) {
                player.pause()
              }
              // if(frame===(apng.frames.lastIndex)&&this.numPlays!==0){
              //   player.pause()
              // }
            });
          })
      })
   })
    },
    //获取父节点宽高
    getWrap(){
        this.wrapHeight=this.$refs.wrap.clientHeight
        this.wrapWidth=this.$refs.wrap.clientWidth
        console.log(this.$refs.wrap,'width')
    },
    calc(val) {
      return this.remVal * val;
    },
    blobToArrayBuffer(blob) {
      return new Promise((resolve) => {
        // Blob 转 ArrayBuffer
        let reader = new FileReader();
        reader.readAsArrayBuffer(blob);
        reader.onload = function() {
          // console.log(reader.result)
          resolve(reader.result)

        }
      })
    },
    loaderURL(url) {
      function createXmlHttpRequest() {
        if (window.ActiveXObject) {
          return new ActiveXObject('Microsoft.XMLHTTP');
        } else if (window.XMLHttpRequest) {
          return new XMLHttpRequest();
        }
      }
      return new Promise((resolve) => {
        let xhr = createXmlHttpRequest();
        xhr.open("get", url, true);
        xhr.responseType = "blob";
        xhr.onload = function (res) {
          if (this.status == 200) {
            var blob = this.response;
            resolve(blob);
          }
        }
        xhr.send();
      })
    }
  }
}
</script>

<style lang="less" scoped>

</style>